import gql from "graphql-tag";
import {ComplianceTicketFragment, TicketTemplateFragment} from "../../../Queries/Veriflyt";
import {
    ComplianceTicketFragmentFragment,
    ComplianceType, CredentialType,
    MangoQueryResult,
    MutationModifyPersonComplianceTicketsArgs,
    QueryPersonComplianceTicketsArgs, TicketTemplateFragmentFragment
} from "../../../__generated__/graphql/types";
import {MutationHookOptions, useMutation, useQuery} from "react-apollo";
import React, {useContext} from 'react';
import {OrgDataContext} from "../../../context/orgData";

export const QUERY_PERSON_COMPLIANCE_TICKETS = gql`
query VeriflytTicketEditor_PersonComplianceTickets(
    $personID: ID!
    $limit: Int
    $skip: Int
    $bookmark: String
){
    PersonComplianceTickets(personID: $personID, limit: $limit, bookmark: $bookmark, skip: $skip){
        docs {
            ... on ComplianceTicket {
                ...ComplianceTicketFragment
            }
        }
        bookmark
    }
}
${ComplianceTicketFragment}
`

export const QUERY_TICKET_TEMPLATE = gql`
query VeriflytTicketEditor_GetTicketTemplate($ticketTemplateID: ID!){
    GetTicketTemplateByID(ticketTemplateID: $ticketTemplateID) {
        ...TicketTemplateFragment
    }
}
${TicketTemplateFragment}
`

export const MutationRegisterToVeriflyt = gql`
    mutation VeriflytTicketEditor_RegisterToVeriflyt($personID: ID!){
        VeriflytUpdateAccount(entityID: $personID) {
            ... on Person {
                _id
                veriflytID
            }
        }
    }
`

export interface UseComplianceDataArgs {
    personID: string,
    limit?: number,
    skip?: number,
    bookmark?: string
}

export function useData(){

}

export function usePersonComplianceTicketsQuery(args: UseComplianceDataArgs) {

    // return usePersonComplianceTicketsQueryMock(args);

    type QueryResult = {
        PersonComplianceTickets: MangoQueryResult
    }

    const result = useQuery<QueryResult, QueryPersonComplianceTicketsArgs>(QUERY_PERSON_COMPLIANCE_TICKETS, {
        variables: {
            personID: args.personID,
            limit: args.limit,
            skip: args.skip,
            bookmark: args.bookmark
        },
        skip: !(args?.personID),
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
    })

    return {
        ...result,
        data: result.data?.PersonComplianceTickets?.docs as ComplianceTicketFragmentFragment[]
    }
}

export const MUTATION_MODIFY_PERSON_COMPLIANCE_TICKETS = gql`
    mutation ComplianceEditor_ModifyPersonComplianceTickets(
        $personID: ID!
        $updateTickets: [ModifyPersonComplianceTicketInput!]
        $deleteTicketIds: [ID!]
    ) {
        ModifyPersonComplianceTickets(
            personID: $personID,
            updateTickets: $updateTickets
            deleteTicketIds: $deleteTicketIds
        ) {
            ticketsResult {
                results {
                    item {
                        ... on ComplianceTicket {
                            ...ComplianceTicketFragment
                        }
                    }
                    success
                    error
                    reason
                }
            }
            ticketsHistoryResult {
                results {
                    item {
                        ... on ComplianceTicket {
                            ...ComplianceTicketFragment
                        }
                    }
                    success
                    error
                    reason
                }
            }
        }
    }
    ${ComplianceTicketFragment}
`

export function usePersonComplianceTicketsMutation(){

    const [ _mutation, result ] = useMutation(MUTATION_MODIFY_PERSON_COMPLIANCE_TICKETS);

    async function mutation(args: MutationModifyPersonComplianceTicketsArgs){
        return _mutation({
            variables: {
                ...args
            }
        })
    }

    return [ mutation, result ] as [ typeof mutation, typeof result]
}

export function useTicketTemplate(ticketTemplateID: string){
    const { data, loading, error } = useQuery(QUERY_TICKET_TEMPLATE, {
        variables: {
            ticketTemplateID: ticketTemplateID
        },
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all',
        skip: !ticketTemplateID
    });

    return {
        ticketTemplate: data?.GetTicketTemplateByID as TicketTemplateFragmentFragment | undefined,
        loading,
        error
    };
}